import React, {FC} from 'react';

// Import Styles
import styled from 'styled-components';

// Import Models and other configuration
import {NewsItem} from '../../../models/newsItem';

// Import Selectors

import SocialShare from '../../../components/Common/SocialShare';

interface IShareNews {
  news: NewsItem
}

const ShareNews: FC<IShareNews> = ({news}) => {


  return (
    <ShareButtonsWrapper>
      <SocialShare 
          title={news.title}
          description={news.body}
      />  
    </ShareButtonsWrapper>
  )
}

const ShareButtonsWrapper = styled.div`
  margin: 16px 0 30px;
  display: flex;
`;

export default ShareNews;